export default __webpack_public_path__ + "static/media/add-to-folder.03b9a7fb.svg";